import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=de3f0e38&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de3f0e38')) {
      api.createRecord('de3f0e38', component.options)
    } else {
      api.reload('de3f0e38', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=de3f0e38&", function () {
      api.rerender('de3f0e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-258xmjW425xN6/JS/videoIframe.vue"
export default component.exports